<template>
    <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
        <div class="form-group mb-0">
            <label class="d-block font-weight-bold">
                {{ label }}
                <span v-if="required" class="text-danger">*</span>
            </label>
            <div class="input-group mb-3">
                <input
                    v-model="item"
                    v-on:input="$emit('input', item)"
                    :type="type ? type : 'text'"
                    class="form-control"
                    :class="classInput"
                    :readonly="readonly"
                    :placeholder="placeholder"
                />
                <div class="input-group-append" v-if="isButton">
                    <button
                        class="btn"
                        :class="btnClass ? btnClass : 'btn-outline-secondary'"
                        type="button"
                        @click="$emit('submit')"
                    >
                        <i :class="iconBtn" v-if="iconBtn"></i>
                        <span v-else>{{ btnText }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "value",
        "label",
        "type",
        "required",
        "grid",
        "readonly",
        "btnText",
        "placeholder",
        "iconBtn",
        "btnClass",
        "isButton",
        "classInput"
    ],
    data() {
        return { item: null };
    },
    beforeMount() {
        this.item = this.value;
    },
    watch: {
        value(n, o) {
            this.item = n;
        }
    }
};
</script>
